import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
var Label = function (_a) {
    var children = _a.children, className = _a.className, helpText = _a.helpText, htmlFor = _a.htmlFor, required = _a.required, renderAs = _a.renderAs;
    var Component = renderAs || 'label';
    return (_jsxs(Component, { className: classNames('form-label', className), htmlFor: htmlFor, children: [children, required ? '*' : '', helpText && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("small", { children: _jsx("i", { children: helpText }) })] }))] }));
};
export default Label;
